module.exports = __webpack_public_path__ + "img/bozoyan.4c193ed3.webp";